import { UI, WebViewerInstance } from '@pdftron/webviewer';

export const applyRedactionsWithoutAttachments = async ({
  instance,
}: {
  instance: WebViewerInstance;
}) => {
  const doc = instance.Core.documentViewer.getDocument();
  const pdfDoc = await doc.getPDFDoc();

  // Access the EmbeddedFiles name tree to find embedded files
  const embeddedFiles = await instance.Core.PDFNet.NameTree.find(
    pdfDoc,
    'EmbeddedFiles',
  );
  if (embeddedFiles) {
    const iterator = await embeddedFiles.getIteratorBegin();
    while (await iterator.hasNext()) {
      // const key = await iterator.key();
      // Remove the embedded file entry from the NameTree
      await embeddedFiles.erase(iterator);
      await iterator.next();
    }
  }

  // Apply the redactions to the document
  await instance.Core.PDFNet.Redactor.redact(pdfDoc, []);

  // Save the modified document
  const data = await pdfDoc.saveMemoryBuffer(
    instance.Core.PDFNet.SDFDoc.SaveOptions.e_linearized,
  );
  const arr = new Uint8Array(data);
  return new Blob([arr]);
};

export const getGroupedItems = (
  instance: WebViewerInstance,
  headerName: string,
  groupedItemDataElement: string,
): UI.Components.GroupedItems | undefined => {
  const { UI } = instance;
  const toolsHeaderGroup = UI.getModularHeader(headerName);
  return toolsHeaderGroup
    .getGroupedItems()
    .find((item) => item.dataElement === groupedItemDataElement);
};
